<template>
<!-- 物资申请 -->
    <div class="declare-view">
        <div style="margin-bottom: 16px">
            <Button @click="batchClick(3)" type="primary">批量通过</Button>
            <Button @click="batchClick(4)" style="margin-left: 10px">批量拒绝</Button>
        </div>
        <Table
            :columns="columns"
            :data="list"
            :height="520"
            class="table-padding-0"
            @on-selection-change="selectionChange"
            ref="list">
            <template slot-scope="{ row }" slot="action">
                <Button size="small" @click="handleClick(1, row)" type="primary" v-if="row.status === 0">通过</Button>
                <Button size="small" @click="handleClick(2, row)" v-if="row.status === 0">拒绝</Button>
                <span v-if="row.status === 1" class="color-s">审核通过</span>
                <span v-if="row.status === 2" class="color-r">审核拒绝</span>
            </template>
        </Table>
        <div class="pages-footer">
            <Page
                :current="page.pageNumber"
                :total="page.total"
                show-sizer
                :page-size="page.pageSize"
                @on-page-size-change="getChangePageSize"
                @on-change="getChangePageNum"/>
        </div>
        <Modal
            v-model="modal"
            title="新物资审核">
            <p v-if="type === 1 || type === 3">确定审核通过所选物资吗？</p>
            <div v-if="type === 2 || type === 4">
                <p style="padding-bottom: 20px">确定审核拒绝所选物资吗？</p>
                <Input v-model="reason" type="textarea" :rows="4" placeholder="请填写原因" />
            </div>
            <div slot="footer">
                <Button @click="closeModal">取消</Button>
                <Button @click="submit" type="primary">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { getAllRequest, checkRequest } from '@/graphql/graphql.js';
import { clone } from '@/assets/js/clone.js';
import expandRow from './table-expand.vue';

export default {
    components: { expandRow },
    data() {
        return {
            list: [],
            page: {
                total: 0,
                pageNumber: 1,
                pageSize: 20
            },
            columns: [
                {
                    align: 'center',
                    type: 'selection',
                    width: 60
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 120
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100
                },
                {
                    title: '物资分类',
                    key: 'classifyName',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100
                },
                {
                    title: '物资单位',
                    key: 'productUnit',
                    minWidth: 100
                },
                {
                    title: '标准单位',
                    key: 'normalProductUnit',
                    minWidth: 100
                },
                {
                    title: '转化率',
                    key: 'rate',
                    minWidth: 100
                },
                {
                    title: '供应商',
                    key: 'supplierName',
                    minWidth: 240
                }
            ],
            modal: false,
            type: null,
            rowInfo: {},
            reason: '',
            selection: [],
            pids: []
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        handleClick(type, row) {
            this.type = type;
            this.rowInfo = row;
            this.modal = true;
        },
        batchClick(type) {
            this.type = type;
            this.pids = [];
            if (this.selection.length) {
                this.selection.forEach(item => {
                    if (item.status === 0) {
                        this.pids.push(item.id);
                    }
                });
                this.modal = true;
            } else {
                this.$setNotice('请选择要审核的物资');
            }
        },
        closeModal() {
            this.modal = false;
        },
        submit() {
            if ((this.type === 2 || this.type === 4) && this.reason === '') {
                this.$setNotice('请填写拒绝原因');
            } else {
                let idss;
                let typ;
                if (this.type === 1 || this.type === 2) {
                    idss = [this.rowInfo.id];
                } else {
                    idss = this.pids;
                }
                if (this.type === 2 || this.type === 4) {
                    typ = 2;
                } else {
                    typ = 1;
                }
                this.$apollo.mutate({
                    mutation: checkRequest,
                    variables: {
                        ids: idss,
                        operate: typ,
                        reason: this.reason
                    }
                }).then(res => {
                    const data = res.data.checkRequest;
                    if (data && data.code === 200) {
                        this.$setNotice('审核成功');
                        this.modal = false;
                        this.getList();
                    } else {
                        this.$setNotice(data.message);
                    }
                });
            }
        },
        getList() {
            this.$apollo.query({
                query: getAllRequest,
                variables: {
                    pageNumber: this.page.pageNumber,
                    pageSize: this.page.pageSize
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getAllRequest;
                if (data && data.data && data.code === 200) {
                    this.page.total = data.count;
                    const list = clone(data.data);
                    list.forEach(item => {
                        item._disabled = false;
                        item._checked = false;
                        if (item.status !== 0) {
                            this.$set(item, '_disabled', true);
                        }
                    });
                    this.list = list;
                }
            });
        },
        selectionChange(sel) {
            this.selection = sel;
        },
        getChangePageNum(val) {
            this.page.pageNumber = val;
            this.getList();
        },

        // pagesize 变化
        getChangePageSize(size) {
            this.page.pageSize = size;
            this.getList();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/review/index.vue